import { flexRender, Header } from "@tanstack/react-table";
import IconButton from "@weave-design/icon-button";
import { CaretUp24, CaretDown24, Sort24 } from "@weave-design/icons";
import { ColumnFilter } from "./columnFilter";
import "./commonTableComponents.css";

type Props<TData> = {
    header: Header<TData, unknown>;
};

export const TableHeaderCell = <TData,>({ header }: Props<TData>) => (
    <th colSpan={header.colSpan}>
        {header.isPlaceholder ? null : (
            <>
                <div className="table-header-sort">
                    <div>{flexRender(header.column.columnDef.header, header.getContext())}</div>

                    {header.column.getCanSort() && (
                        <IconButton
                            icon={
                                {
                                    asc: <CaretUp24 />,
                                    desc: <CaretDown24 />,
                                }[header.column.getIsSorted() as string] ?? <Sort24 />
                            }
                            title="Sort"
                            onClick={header.column.getToggleSortingHandler()}
                        />
                    )}
                </div>

                {header.column.getCanFilter() && (
                    <div>
                        <ColumnFilter column={header.column} />
                    </div>
                )}
            </>
        )}
    </th>
);
